module.exports = __webpack_public_path__ + "img/hbdesf.56bdbdd7.png";